export default __webpack_public_path__ + "df0381e7b734875ab89000e9fc29a6a3.svg";